import { useFetchBondPreviews } from "@portal/api/previews";
import { FilterableDataTable } from "@portal/components/ui/FilterableDataTable";
import { useIsMinimalBondUIEnabled } from "@portal/hooks/useIsMinimalBondUIEnabled";
import { FC, useMemo } from "react";
import { getBondTableColumns } from "./columns";

export const BondPreviewsOpen: FC = () => {
	const { bondPreviews } = useFetchBondPreviews();
	const isMinimalUIEnabled = useIsMinimalBondUIEnabled();

	const openBondPreviews = useMemo(
		() => bondPreviews?.filter((preview) => preview.status === "open"),
		[bondPreviews],
	);
	const columns = useMemo(() => getBondTableColumns(isMinimalUIEnabled), [isMinimalUIEnabled]);

	return (
		<FilterableDataTable
			name="bonds_open"
			columnDefs={columns}
			getRowUrl={(row) => `/bonds/${row.id}`}
			data={openBondPreviews}
			loadingMessage="Loading bonds..."
			enableExportToCSV
		/>
	);
};
